import { IconClockExclamation } from '@tabler/icons-react'

// Shown in public drive/portfolio/share views when the drive's user-defined access
// period has expired. Instead of the content and album listing, the visitor sees a
// hint that access has expired and to contact the photographer.
export default function AccessExpiredElement() {
  return (
    <div className="container mx-auto flex flex-col gap-3 justify-center items-center px-4 py-20 text-content">
      <IconClockExclamation size={48} className="opacity-60" />
      <p className="text-2xl text-center font-bold font-serif">Zugriff abgelaufen</p>
      <p className="text-center max-w-[32rem] opacity-80">
        Der Zugriff auf diese Galerie ist abgelaufen. Bitte kontaktiere den Fotografen, um wieder Zugriff zu erhalten.
      </p>
    </div>
  )
}
